import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';
import type { Size } from './types';
import { cn } from './utils';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    size?: Size;
    variant?: 'default' | 'ghost' | 'danger' | 'primary';
    label: string;
    children: ReactNode;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        {
            className,
            size = 'md',
            variant = 'default',
            label,
            children,
            type = 'button',
            ...props
        },
        ref,
    ) => {
        return (
            <button
                ref={ref}
                type={type}
                aria-label={label}
                title={props.title ?? label}
                className={cn(
                    'nx-icon-btn',
                    size === 'sm' && 'nx-icon-btn--sm',
                    size === 'md' && 'nx-icon-btn--md',
                    size === 'lg' && 'nx-icon-btn--md',
                    variant === 'ghost' && 'nx-icon-btn--ghost',
                    variant === 'danger' && 'nx-icon-btn--danger',
                    variant === 'primary' && 'nx-icon-btn--primary',
                    className,
                )}
                {...props}
            >
                {children}
            </button>
        );
    },
);

IconButton.displayName = 'IconButton';

export { IconButton };
export type { IconButtonProps };
